import styled from 'styled-components'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  align-self: center;
  gap: 16px;
`

const LabelContainer = styled.div`
  width: 12px;
  height: 12px;
  background-color: ${({ color }) => color};
  margin-right: 5px;
`

const Label = styled.span`
  font-size: 12px;
  color: #666e7b;
`

const CustomChartLegend = ({ visibleSeries, toggleSeries, legends }) => {
  const { t } = useTranslation('common')
  const translatedLabels = {
    bad: t('bad'),
    regular: t('regular'),
    good: t('good'),
  }

  return (
    <Container>
      {legends.map(legend => (
        <div
          key={legend.label}
          onClick={() => toggleSeries(legend.label)}
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            opacity: visibleSeries[legend.label] ? 1 : 0.5,
          }}
        >
          <LabelContainer color={legend.color} />
          <Label>
            {translatedLabels[legend.label]
              ? translatedLabels[legend.label]
              : legend.label}
          </Label>
        </div>
      ))}
    </Container>
  )
}

export default CustomChartLegend
